import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const EditCustomLocale = React.lazy(
    () => import("@mediaspace-react-components/features/edit-custom-locale/EditCustomLocale")
);

export const render = getStandaloneComponentRenderer(EditCustomLocale, true);
